<template>
    <div>
        <h1 class="display-heading">{{title}}</h1>

        <div ref="tableSection">
            <div class="d-md-none">
                <div class="card mb-3" v-show="appointmentList.length === 0">
                    <div class="card-body">
                        {{isTableLoading ? "Loading Data": "No Data"}}
                    </div>
                </div>

                <div class="card mb-3" v-for="(appointment, index) in appointmentList" :key="index">
                    <div class="card-body">
                        <div class="mb-3">
                            <label class="label-display">
                                Date
                            </label>
                            <div>
                                {{appointment.date}}
                            </div>
                        </div>
                        <div class="mb-3">
                            <label class="label-display">
                                Time
                            </label>
                            <div>
                                {{appointment.time}}
                            </div>
                        </div>
                        <div class="mb-3">
                            <label class="label-display">
                                Doctor Name
                            </label>
                            <div>
                                {{appointment.doctorName}}
                            </div>
                        </div>
                        <div class="mb-3">
                            <label class="label-display">
                                Status
                            </label>
                            <div class="mt-2">
                                <appointment-status-patient :statusId="appointment.statusId"></appointment-status-patient>
                            </div>
                        </div>
                        <div>
                            <label class="label-display">
                                Action
                            </label>
                            <div class="mt-2">
                                <appointment-action-patient
                                    :statusId="appointment.statusId"
                                    :appointmentId="appointment.id"
                                    :consultationId="appointment.consultationId"
                                    :isConsultationStarted="appointment.consultationStatusId === 2">
                                </appointment-action-patient>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="d-none d-md-block">
                <div class="table-responsive">
                    <table ref="listTable" class="table table-hover">
                        <colgroup>
                            <col width="40">
                            <col width="140">
                            <col width="140">
                            <col>
                            <col width="180">
                            <col width="250">
                        </colgroup>
                        <thead>
                            <tr>
                                <th scope="col">#</th>
                                <th scope="col">Date</th>
                                <th scope="col">Time</th>
                                <th scope="col">Doctor Name</th>
                                <th scope="col">Status</th>
                                <th scope="col">Action</th>
                            </tr>
                        </thead>

                        <tbody>
                            <tr v-show="appointmentList.length === 0">
                                <td :colspan="columnsCount" class="text-center font-italic">
                                    {{isTableLoading ? "Loading Data": "No Data"}}
                                </td>
                            </tr>
                            <tr v-for="(appointment, index) in appointmentList" :key="index">
                                <th scope="row">{{((pagination.currentPage - 1) *pagination.pageSize ) + index + 1}}</th>
                                <td class="text-nowrap">{{appointment.date}}</td>
                                <td class="text-nowrap">
                                    {{appointment.time}}
                                </td>
                                <td>{{appointment.doctorName}}</td>
                                <td>
                                    <!-- render status labels -->
                                    <appointment-status-patient :statusId="appointment.statusId"></appointment-status-patient>
                                </td>
                                <td>
                                    <appointment-action-patient
                                        :statusId="appointment.statusId"
                                        :appointmentId="appointment.id"
                                        :consultationId="appointment.consultationId"
                                        :isConsultationStarted="appointment.consultationStatusId === 2">
                                    </appointment-action-patient>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <pagination v-model="pagination.currentPage"
                :totalPages="pagination.totalPages"
                :scrollPosition="pagination.scrollPosition">
            </pagination>
        </div>
    </div>
</template>

<script>
import patientAppointmentList from '@/mixins/patient-appointment-list';
export default {
    'mixins': [patientAppointmentList],
    data () {
        return {
            'title': 'Cancelled Consultations',
            'appointmentFilterList': [99, 999]
        };
    }
};
</script>
